'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$UnsignedFileBase64(hash, content) {
  this.Nv = null;
  this.Nu = null;
  this.Nv = hash;
  this.Nu = content;
}
export { $c_Lpresto_types$proto$UnsignedFileBase64 as $c_Lpresto_types$proto$UnsignedFileBase64 };
$p = $c_Lpresto_types$proto$UnsignedFileBase64.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$UnsignedFileBase64;
/** @constructor */
function $h_Lpresto_types$proto$UnsignedFileBase64() {
}
export { $h_Lpresto_types$proto$UnsignedFileBase64 as $h_Lpresto_types$proto$UnsignedFileBase64 };
$h_Lpresto_types$proto$UnsignedFileBase64.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$UnsignedFileBase64) && ((this.Nv === x$0.Nv) && (this.Nu === x$0.Nu))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "UnsignedFileBase64";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Nv;
  }
  if ((n === 1)) {
    return this.Nu;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$UnsignedFileBase64(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mc)));
}
export { $isArrayOf_Lpresto_types$proto$UnsignedFileBase64 as $isArrayOf_Lpresto_types$proto$UnsignedFileBase64 };
var $d_Lpresto_types$proto$UnsignedFileBase64 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$UnsignedFileBase64, "presto.types$proto$UnsignedFileBase64", ({
  mc: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$UnsignedFileBase64 as $d_Lpresto_types$proto$UnsignedFileBase64 };
//# sourceMappingURL=presto.types$proto$-Unsigned-File-Base64.js.map
